import {
    DomainInitPayload,
    OfferDetails,
    OfferDisplayInfo,
    Subscription,
} from '@sxm-de/dev-kits/web-sdk/types';
import { getSubscriptions } from '../helpers/get-subscriptions';
import {
    getOfferCmsDisplayName,
    getOfferDetails,
} from '@sxm-de/dev-kits/web-sdk/domains/offers';
import { getOfferSummaries } from '../mappers/get-offer-summaries';

export type GetSubscriptionsWithOfferDetailsFn = () => Promise<{
    subscriptions: Subscription[];
    offerDisplayInfo: OfferDisplayInfo;
    offerDetailsSet: OfferDetails[];
}>;

export function initGetSubscriptionsWithOfferDetailsFn({
    dependencies,
}: DomainInitPayload): GetSubscriptionsWithOfferDetailsFn {
    const { appEventSdk, clientSdk } = dependencies;
    return async () => {
        const { subscriptions } = await getSubscriptions(dependencies);
        const offerIds = [
            ...new Set(
                subscriptions.reduce((offerIds: string[], subscription) => {
                    return [
                        ...offerIds,
                        subscription.offerId,
                        ...(subscription.offers.active
                            ? [subscription.offers.active.id]
                            : []),
                        ...(subscription.offers.pending
                            ? [subscription.offers.pending.id]
                            : []),
                    ];
                }, []),
            ),
        ];

        const offerDisplayInfo = await getOfferCmsDisplayName(
            { offerIds },
            dependencies,
        );

        const offerDetailsSet: OfferDetails[] = [];
        for (const offerId of offerIds) {
            const offerDetails = await getOfferDetails(
                { offerId },
                dependencies,
            );
            offerDetailsSet.push(offerDetails);
        }

        const subscriptionsMapped = subscriptions.map((subscription) => {
            return {
                ...subscription,
                ...getOfferSummaries(
                    subscription.offers,
                    subscription.currentPhase,
                    offerDetailsSet,
                    subscription.state,
                ),
            };
        });

        return {
            subscriptions: subscriptionsMapped,
            offerDisplayInfo,
            offerDetailsSet,
        };
    };
}
